<template>
  <div class="licence-page">
    <h2 class="main-title">저작권</h2>
    <div class="sub-description font-24">
      <p>가비아 글꼴에 대한 저작권은 글꼴 디자이너에게 있습니다.<br> 독점 사용권, 글꼴 이름에 대한 저작권은 (주)가비아가 소유합니다.</p>
      <p>모든 사용자(개인, 기업)는 가비아 글꼴을 무료로 이용할 수 있습니다.<br> 상업적 목적의 작업물 제작에도 사용할 수 있습니다.<br> 단, 글꼴 자체를 유료로 판매하거나,
        수정 및 재배포하는 것은 금지합니다.</p>
      <p>(주)가비아는 가비아 글꼴을 사용한 결과물을 (주)가비아 홍보에 활용할 수 있습니다.<br> 다만, 이를 원치 않는 사용자는 (주)가비아에 활용 금지를 요청할 수
        있습니다.</p>
    </div>
    <div class="page-contents">
      <div class="page-contents-tab-wrapper">
        <div class="tab-menu-btns">
          <div class="tab-menu-item" v-for="item in licenceMenu" :key="item.name"
               :class="{active: item.name === selectedMenu}"
               @click="selectTabMenu(item.name)">
            <span class="item-title">{{item.title}}</span>
          </div>
        </div>
        <div class="tab-contents-wrapper">
          <table>
            <thead>
              <tr>
                <th>사용범위</th>
                <th>사용가능 여부</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="type in licenceList[selectedMenu]" :key="type.useType">
                <td >
                  {{type.useType}}
                </td>
                <td>
                  <div class="usedCheck">
                    <template v-if="type.isUsed">
                      <img src="https://static.gabia.com/fonts/project/image/true_mark.svg" alt="true">
                    </template>
                    <template v-else>
                      <img src="https://static.gabia.com/fonts/project/image/false_mark.svg" alt="false">
                    </template>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LicencePage',
  data() {
    return {
      selectedMenu: 'prints',
      licenceMenu: [
        { name: 'prints', title: '인쇄물' },
        { name: 'ci_bi', title: 'C.I/B.I' },
        { name: 'web_site', title: '웹사이트' },
        { name: 'video', title: '영상' },
        { name: 'device', title: '디바이스' },
        { name: 'server', title: '서버' },
        { name: 'e_book', title: 'E-book' },
        { name: 'etc', title: '기타' },
      ],
      licenceList: {
        prints: [
          { useType: '브로슈어, 카탈로그, 전단지, 포스터, 우편(DM), 달력 등 인쇄물', isUsed: true },
          { useType: '책, 만화책, 잡지, 정기간행물, 신문 등 출판물', isUsed: true },
          { useType: '간판, 현수막, 판넬, 등 제작물', isUsed: true },
          { useType: '신문광고, 잡지광고, 차량광고 등 광고물', isUsed: true },
          { useType: '신문 제목 및 텍스트', isUsed: true },
          { useType: '인쇄 및 문서 공유를 위한 PDF 파일 제작', isUsed: true },
        ],
        ci_bi: [
          { useType: '회사명, 브랜드명, 상품명, 로고, 마크, 슬로건, 캐치프레이즈', isUsed: true },
        ],
        web_site: [
          { useType: '웹페이지, 광고배너, 메일, 웹툰, E-카탈로그', isUsed: true },
          { useType: '웹서버용 글꼴', isUsed: true },
        ],
        video: [
          { useType: '방송 및 영상물 자막', isUsed: true },
          { useType: '영상 광고(TV/온라인)', isUsed: true },
          { useType: '영화(DVD/비디오) 및 자막(오프닝/엔딩 크레딧)', isUsed: true },
          { useType: '개인 제작 콘텐츠(UCC) 및 홍보물', isUsed: true },
          { useType: '온라인 교육 콘텐츠 (E-Learning 콘텐츠, 동영상 강좌 등)', isUsed: true },
        ],
        device: [
          { useType: '스마트폰, MP3, PMP, 내비게이션, 셋탑박스, 게임기 등의 운영체제 내 탑재', isUsed: true },
          { useType: '어플리케이션 GUI디자인 등', isUsed: true },
          { useType: '전광판 및 안내시스템, ATM기기 등', isUsed: true },
        ],
        server: [
          { useType: '서버 탑재 후 웹서비스 및 프로그램 내 서비스(게임 등)', isUsed: true },
        ],
        e_book: [
          { useType: 'E-Book 기기 내 UI 제작, 폰트탑재', isUsed: true },
          { useType: '도서 및 잡지 등을 E-Book 콘텐츠(ePUB, PDF)로 변환 서비스', isUsed: true },
        ],
        etc: [
          { useType: '직접 판매 목적의 이미지 제작(2차 제작결과물) ', isUsed: true },
          { useType: '스탬프, T셔츠 등 서체 디자인이 직접 활용된 상품 제작', isUsed: true },
          { useType: '글꼴 파일 유료 판매', isUsed: false },
        ],
      },
    };
  },
  methods: {
    selectTabMenu(item) {
      this.selectedMenu = item;
    },
  },
};

</script>

<style lang="scss" scoped>
.licence-page {
  width: 980px;
  margin: 0 auto;
  text-align: center;
  .main-title {
    margin-bottom :80px;
  }
  .sub-description {
    margin-bottom: 80px;
    p {
      margin-bottom: 30px;
    }
  }
  .page-contents {
    padding-top: 80px;
    padding-bottom: 80px;
    border-top: 1px solid #0a0a0a;
    min-height: 1000px;
  }
}
.page-contents-tab-wrapper {
  .tab-menu-btns {
    flex-wrap: wrap;
    display: flex;
    -moz-column-gap: 68px;
    column-gap: 68px;
    row-gap: 40px;
    width: 80%;
    justify-content: center;
    margin: 0 auto;
    margin-bottom: 80px;
    .tab-menu-item {
      cursor: pointer;
      flex-shrink: 0;
      font-size: 30px;
      font-weight: 600;
      &.active {
        border-bottom: 2px solid #0a0a0a;
      }
    }
  }
}
table {
  width: 978px;
  background-color: #f2f2f2;
  border-spacing: 0;
  border:1px solid #0a0a0a;
  th {
    background-color: #000000;
    color: #ffffff;
    padding: 35px;
    border-right: 1px solid #ffffff;
    &:last-child {
      border: 0;
      width: 250px;
    }
  }
  td {
    padding: 25px;
    text-align: center;
    border-right: 1px solid #0a0a0a;
    .usedCheck {
      width: 100%;
      height: 24px;
      img {
        height: 100%;
      }
    }
    &:last-child {
      border: 0;
    }
  }
}
.contents-item {
  width: 100%;
  padding: 50px;
  text-align: center;
}
</style>
